import imagesExtensionsEnum from '@/shared/enums/imagesExtensionsEnum'

// Case-insensitive: "IMG_1234.JPG" must be stored as a url string like "dni.jpg"
export const isImageFileName = name => {
  const parts = name?.split('.') ?? []
  return parts.length > 1 && imagesExtensionsEnum.includes(parts.pop().toLowerCase())
}
